import _ from 'lodash'
import conductor from 'scoreboard/components/conductor'
import httpsValidator from 'scoreboard/components/validators/https-validator'

// a Model of the item currently being viewed, which may be a Bookmark
// or a Slide
var current
// the previous value for current
var previous
// true when we're initially loading a bookmark or bb slide
var initialLoad

var spectator = {

	// get a Model of the item currently being viewed, which may be a Bookmark
	// or a Slide.  this method has to look at the URL so that it will work
	// even before a route has executed (since that's the only event Backbone
	// gives us)
	getCurrent: function() {
		if (initialLoad || this.spectates(conductor.section())) {
			return current
		} else {
			return null
		}
	},

	// set the Model of the item currently being viewed, which may be a Bookmark
	// or a Slide
	setCurrent: function(c) {
		previous = current
		current = c
		initialLoad = true
		process.nextTick(function() {
			initialLoad = false
		})
	},

	/**
	 * When a spectated domain object is loaded (in base-router.js) it is passed
	 * here.  This gives us a chance to extract attributes like projectId into
	 * the global state which is needed when showing components that depend on
	 * this spectated model instead of the global attributes.
	 *
	 * @param model
	 * @return the current model with attributes of `model` merged if
	 * current.spectated.id == model.id, or null if nothing is being spectated
	 */
	merge(model) {
		const c = this.getCurrent()
		if (c && model && _.get(c, 'attributes.spectated.id') == model.id) {
			const { projectId, organizationId } = model.attributes
			projectId && c.set('projectId', projectId)
			organizationId && c.set('organizationId', organizationId)
		}
		return c
	},

	getPrevious: function() {
		return previous
	},

	/**
	 * If the current model (e.g. Bookmark) was returned from the server with
	 * an id of the spectated resource, this function returns the domainId of
	 * the source domain object.
	 *
	 * Otherwise, it returns the id of the current model if a spectated resource
	 * is active (bookmark or slide).
	 *
	 * If nothing is being spectated it will return id of the current domain
	 * object, if any, using conductor.id()
	 *
	 *
	 * Supports #22679
	 */
	getCurrentId() {
		const model = this.getCurrent()
		return _.get(model, 'attributes.spectated.id',
			_.defaultTo(_.get(model, 'id'), conductor.id()))
	},

	/**
	 * Returns whether the section is one that doesn't have its own display,
	 * but rather displays the screens within some other section
	 */
	spectates: function(section) {
		return section === 'bookmarks' || section === 'briefings'
	},

	/**
	 * Returns true if the current spectated item links to an external web page, else false.
	 */
	isCurrentExternalUrl: function() {
		return !httpsValidator(current.get('url'))
	},

	/**
	 * Returns a formatted briefings slide or bookmarks url
	 * (ex. /briefings/101/slides/323 or /bookmarks/234) for a given spectated item
	 */
	buildSpectatedUrl: function(spectated) {
		let section = conductor.section()
		if (section == 'briefings') {
			return section + '/' + conductor.id() + '/slides/' + spectated.id
		} else {
			return section + '/' + spectated.id
		}
	},

	/**
	 * Returns the currect url according to whether the spectated item is an
	 * externally linking slide or an item which already has a properly formatted
	 * internal url.
	 */
	getCurrentUrl: function() {
		// Current is an external web link
		if (this.isCurrentExternalUrl()) {
			return this.buildSpectatedUrl(current)
		// Else, current is a regulular spectated item
		} else {
			return current.get('url')
		}
	}
}

export default spectator
export const isSpectating = () => !_.isNil(spectator.getCurrent())

spectator.__filename__ = 'components/spectator.js'
